import { AfterViewInit, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActionData, ActionsOperators, BullhornFieldType, Entities } from '../../data-rules-model';
import { AutocompleteComponent } from '../../lib/autocomplete/autocomplete.component';
import { StaticOptionsProvider } from '../../lib/option-items-providers';
import { MetaDataService } from '../../meta-data.service';

@Component({
  selector: 'app-action-parse-resume',
  templateUrl: './parse-resume.component.html',
  styleUrls: ['./parse-resume.component.scss'],
  imports: [ReactiveFormsModule, AutocompleteComponent]
})
export class ParseResumeComponent implements AfterViewInit, OnDestroy {
  @Input() actionData: ActionData;
  @Input() actionForm: FormGroup;
  @Input() primaryEntity: Entities;

  @ViewChild('resumeFieldPicker') private resumeFieldPicker: AutocompleteComponent;
  @ViewChild('resumeDateFieldPicker') private resumeDateFieldPicker: AutocompleteComponent;

  actionTypeControl: FormControl;
  resumeTypeControl: FormControl;
  fieldToPopulateWithResumeControl: FormControl;
  fieldToPopulateWithResumeDateControl: FormControl;

  constructor(private metaDataService: MetaDataService) {
  }

  ngAfterViewInit(): void {
    this.createControls();

    this.metaDataService.getActionMeta(this.primaryEntity).subscribe(fields => {
      const textOptions = fields
        .filter(f => !f.readOnly && f.metaType === BullhornFieldType.STRING)
        .map(f => ({name: f.fieldName, label: f.label}));
      const dateOptions = fields
        .filter(f => !f.readOnly && f.metaType === BullhornFieldType.DATE)
        .map(f => ({name: f.fieldName, label: f.label}));

      this.resumeFieldPicker.setOptionsProvider(new StaticOptionsProvider(textOptions), this.fieldToPopulateWithResumeControl.value);
      this.resumeDateFieldPicker.setOptionsProvider(new StaticOptionsProvider(dateOptions), this.fieldToPopulateWithResumeDateControl.value);
    });
  }

  private createControls(): void {
    this.actionTypeControl = new FormControl(this.actionData.type);
    this.resumeTypeControl = new FormControl(this.actionData.value?.resumeType ?? '', Validators.required);
    this.fieldToPopulateWithResumeControl = new FormControl(this.actionData.value?.fieldToPopulateWithResume ?? null, Validators.required);
    this.fieldToPopulateWithResumeDateControl = new FormControl(this.actionData.value?.fieldToPopulateWithResumeDate ?? null, Validators.required);

    this.actionForm.addControl('type', this.actionTypeControl);
    this.actionForm.addControl('resumeType', this.resumeTypeControl);
    this.actionForm.addControl('fieldToPopulateWithResume', this.fieldToPopulateWithResumeControl);
    this.actionForm.addControl('fieldToPopulateWithResumeDate', this.fieldToPopulateWithResumeDateControl);
    this.actionTypeControl.setValue(ActionsOperators.PARSE_RESUME);
  }

  ngOnDestroy(): void {
    this.actionForm.removeControl('type');
    this.actionForm.removeControl('resumeType');
    this.actionForm.removeControl('fieldToPopulateWithResume');
    this.actionForm.removeControl('fieldToPopulateWithResumeDate');
  }
}
